/** A value that follows its target like a weight on a spring: overshoots a little and settles. */
export class Spring {
  value: number;
  private velocity = 0;

  constructor(value = 0, private readonly stiffness = 180, private readonly damping = 18) {
    this.value = value;
  }

  /** A sudden push, as from a punch landing. */
  kick(speed: number): void {
    this.velocity += speed;
  }

  update(target: number, seconds: number): number {
    const force = (target - this.value) * this.stiffness - this.velocity * this.damping;
    this.velocity += force * seconds;
    this.value += this.velocity * seconds;
    return this.value;
  }
}
